///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { NgModule } from '@angular/core';
import { GtthStepsToolbarComponent } from './steps-toolbar.component';
import { GtthStepEnterLocationComponent } from './step-enter-location/step-enter-location.component';
import { GtthStepLosComponent } from './step-los/step-los.component';
import { GtthStepPlanComponent } from './step-plan/step-plan.component';
import { GtthStepReportsComponent } from './reports/step-reports.component';
import { GtthStepBOMComponent } from './step-bom/step-bom.component';
import { GtthSharedModule } from '../../shared/shared.module';
import { ContextSensitiveHelpComponent } from '../../shared/context-sensitive-help/ctx-sensitive-help.component';
import { SuiTranslatePipe } from '@siklu/sui-lib';

@NgModule({
    imports: [GtthSharedModule, ContextSensitiveHelpComponent, SuiTranslatePipe],
    declarations: [
        GtthStepsToolbarComponent,
        GtthStepEnterLocationComponent,
        GtthStepLosComponent,
        GtthStepPlanComponent,
        GtthStepReportsComponent,
        GtthStepBOMComponent
    ],
    providers: [],
    exports: [GtthStepsToolbarComponent]
})
export class GtthStepsToolbarModule {}
